import { mapState, mapMutations } from "vuex";
import moment from "moment";

import Input from "../../../components/UI/CustomInputs/Input.vue";
import InputMoney from "../../../components/UI/CustomInputs/InputMoney.vue";
import InputQuant from "../../../components/UI/CustomInputs/InputQuant.vue";
import InputPercentage from "../../../components/UI/CustomInputs/InputPercentage.vue";
import InputInfinit from "../../../components/UI/CustomInputs/InputInfinit.vue";
import Tabs from "../../../components/UI/Tabs/Tab.vue"
import ModalCreateProducts from "../../Modals/ModalCreateProduct.vue"

import ServiceCustomer from "../../../services/serviceCustomer";
import ServiceProducts from "../../../services/serviceProducts";
import ServiceProductionOrderItem from "../../../services/serviceProductionOrderItem";
import ServiceProductionOrder from "../../../services/serviceProductionOrder";

import { ValidadeProductionOrderItem } from "../../../validators/productionOrderItem";

import { maskCurrency, maskPercentage, } from "../../../utils/maskMoney";
import { removeReference } from "../../../utils/removeReference";
import { HandleErrors } from "../../../utils/handleErrors";

export const mixinSimpleItem = {
  props: {
    productionOrder: {
      type: Object
    }
  },
  components: {
    Input,
    InputMoney,
    InputQuant,
    InputPercentage,
    InputInfinit,
    ModalCreateProducts,
    Tabs,
  },
  data() {
    return {
      blocked: false,
      comissao: "",
      productUnitaryValue: "",
      fields: ["Produto", "Quantidade", "Valor"],
      totalParcelas: 1,
      intervaloDias: 0,
      discountToAllItems: false,
      discountIsCheked: false,
      productionOrderIsCanceled: false,
      situationSelected: null,
      createdNewCustomer: false,
      createdNewEmployee: null,
      createdNewProducts: null,
      maskCurrency: maskCurrency,
      idProductFromSearch: "",
      lineSimpleItem: {
        id: "",
        idOrdemProducao: "",
        idFornecedor: "",
        idProduto: "",
        quantidade: 1,
        altura: 0,
        largura: 0,
        metragem: 0,
        valorUnitario: 0,
        valorTotal: 0,
        desconto: 0,
        dadosAdicionais: "",
        porcentagemPerda: 0,
        idCor: "",
        idAmbiente: "",
        linear: false,
        tipoPreco: "P1",
        tipoItem: "simples",
        estoque: 0,
        tipoDesconto: "valor_monetario"
      },
      toggleToUpdate: false,
      selectedItemIdToReplace: null,
      productLoading: false,
      toggleClearSelect: false,
      tableProducts: [],
      prevSelectedProduct: null,
      maskPercentage: maskPercentage,
      isLoadingToDelete: false,
      isLoadingToReplace: false,
      editProd: {
        edit: false,
        prod: null
      },
    };
  },
  methods: {
    ...mapMutations([]),
    async handleAddMoreItems() {
      if (!this.productionOrder.idCliente) {
        return this.$toast.open({
          message: "(Cliente) deve ser selecionado para prosseguir",
          type: "info",
        });
      }

      await this.saveProdutionOrder()

      this.lineSimpleItem.id
        ? await this.updateProductItem()
        : await this.saveProductionItem();

      this.handleCalculateTotalsValues();

      this.editProd = {
        edit: false,
        prod: null
      };
    },

    async saveProductionItem() {
      try {
        this.lineSimpleItem.idOrdemProducao = this.productionOrder.id;

        if (!this.validadeProductOfProductionOrder(this.lineSimpleItem)) return;

        await ServiceProductionOrderItem.save({ ...this.lineSimpleItem });
        await this.findTableItemsOfProducionOrder();
        this.clearLineProduct();

        return this.$toast.open({
          message: "Produto adicionado",
          type: "success",
        });
      } catch (error) {
        console.log(error)
        const typeError = HandleErrors(error?.response?.data?.message);

        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : typeError?.message ? typeError?.message : error?.response?.data?.message ||
              "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      } finally {
        this.productLoading = false;
      }
    },

    async updateProductItem() {
      try {
        this.lineSimpleItem.idOrdemProducao = this.productionOrder.id;

        if (!this.validadeProductOfProductionOrder(this.lineSimpleItem)) return;

        await ServiceProductionOrderItem.update(this.lineSimpleItem.id, this.lineSimpleItem);
        await this.findTableItemsOfProducionOrder();
        this.clearLineProduct();

        return this.$toast.open({
          message: "Produto atualizado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : error?.response?.data?.message ||
            "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      } finally {
        this.productLoading = false;
      }
    },

    async saveProdutionOrder() {
      try {
        this.productLoading = true;
        if (this.productionOrder.id) return;

        const result = await ServiceProductionOrder.save(this.productionOrder);

        this.$emit('productionOrderIdAndNumber', { id: result.id, number: result.number });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao salvar",
          type: "info",
        });

        this.productLoading = false;
      }
    },

    async updateProductionOrder() {
      await ServiceProductionOrder.update(this.productionOrder);
    },

    async removeItens(id) {
      try {
        this.isLoadingToDelete = true
        await ServiceProductionOrderItem.delete(id);
        await this.findTableItemsOfProducionOrder();

        this.handleCalculateTotalsValues();
        return this.$toast.open({
          message: "Produto removido",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.message}` ||
            "Ocorreu um erro ao remover o produto!",
          type: "info",
        });
      } finally {
        this.isLoadingToDelete = false
      }
    },

    async alterDiscountIsCheked() {
      this.discountIsCheked = !this.discountIsCheked;

      if (this.discountIsCheked) {
        this.lineSimpleItem.tipoDesconto = "porcentagem";
        this.$refs.enableLabelApplyAll.style.display = "block";
      } else {
        this.lineSimpleItem.tipoDesconto = "valor_monetario";
        this.$refs.enableLabelApplyAll.style.display = "none";
        this.discountToAllItems = false;
      }

      if (this.productionOrder.id) await this.updateProductionOrder();

      this.handleCalculateTotalsValues();
      this.handleCalculateTotal();
    },

    async getProductById(idProduct) {
      const data = await ServiceProducts.getProductById(idProduct);
      return data;
    },

    async handleSetProductValues(product) {
      if (product) {
        if (this.prevSelectedProduct && (product.id !== this.prevSelectedProduct.id)) {
          this.lineSimpleItem.valorUnitario = this.editProd.edit ? this.editProd.prod.valorUnitario : product.valorVenda;
          this.$refs.refVlUnit.valueInput = this.editProd.edit ? this.editProd.prod.valorUnitario : product.valorVenda

          this.handleCalculateTotal();
          this.editProd = {
            edit: false,
            prod: null
          };
        }

        this.prevSelectedProduct = product;
        this.lineSimpleItem.estoque = await ServiceProducts.findStock(product.id);

        if (!this.lineSimpleItem.id) {
          this.lineSimpleItem.valorUnitario = product.valorVenda;
          this.$refs.refVlUnit.valueInput = product.valorVenda;

          const amount = Number(this.lineSimpleItem.quantidade);
          const unitaryValue = this.lineSimpleItem.valorUnitario;
          const total = amount * unitaryValue;

          this.lineSimpleItem.valorTotal = total;
          this.$refs.valorTotal.valueInput = total;

          this.updateProductValue(this.lineSimpleItem.tipoPreco || "P1");
        }
      }
    },

    async applyReplaceAll() {
      try {
        this.isLoadingToReplace = true
        await ServiceProductionOrderItem.replaceAll(
          this.lineSimpleItem,
          this.selectedItemIdToReplace,
          this.productionOrdeIid,
          this.lineSimpleItem.tipoPreco
        );

        this.cancelReplaceAll();
        this.clearLineProduct();
        await this.findTableItemsOfProducionOrder();

        this.handleCalculateTotalsValues();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao substituir os itens",
          type: "info",
        });
      } finally {
        this.isLoadingToReplace = false
      }
    },

    async handleDuplicate(itemsOfProductionOrder) {
      try {
        const newProd = removeReference(itemsOfProductionOrder);
        newProd.id = "";
        newProd.createdAt = null

        await ServiceProductionOrderItem.save(newProd);
        await this.findTableItemsOfProducionOrder();
        this.handleCalculateTotalsValues()

        this.$toast.open({
          message: "Item Clonado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao clonar o item",
          type: "info",
        });
      }
    },

    async findTableItemsOfProducionOrder() {
      const result = await ServiceProductionOrderItem.findByIdProductionOrderPerTypeItem(this.productionOrder.id, 'simples');

      this.tableProducts = result || [];

      if (this.tableProducts.length) {
        const isCheckedDicount = this.tableProducts.find(item => item.tipoDesconto)

        if (isCheckedDicount.tipoDesconto === "porcentagem") {
          this.discountIsCheked = true;

          this.$refs.enableLabelApplyAll.style.display = "block";
        }
      }

      this.$emit('productionOrderItems', this.tableProducts)
    },

    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(id, q, filterType, page);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    async fillCustomerComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceCustomer.fillComboBoxWithPaginate(id, q, filterType, page);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os clientes",
          type: "info",
        });
      }
    },

    updateProductValue(selected) {
      const valueMapping = {
        P1: this.prevSelectedProduct.valorVenda,
        P2: this.prevSelectedProduct.valorVenda2,
        P3: this.prevSelectedProduct.valorVenda3,
      };

      const currencyValueProduct = valueMapping[selected];

      this.lineSimpleItem.valorUnitario = currencyValueProduct;

      if (this.$refs.refVlUnit) {
        this.$refs.refVlUnit.valueInput = currencyValueProduct;
      }

      this.handleCalculateTotal();
    },

    validadeProductOfProductionOrder(prod) {
      const isNotValid = ValidadeProductionOrderItem(prod);

      if (isNotValid && Object.keys(isNotValid).length) {
        this.$toast.open({
          message: isNotValid.message,
          type: "info",
        });

        return false;
      }

      return true;
    },

    cancelReplaceAll() {
      this.selectedItemIdToReplace = null;
      this.clearLineProduct();
    },

    handleCalculateTotalInTable(prod) {
      let newTotalValue = 0;

      if (prod.tipoDesconto === "porcentagem") {
        const result = (prod.valorTotal * (prod.desconto / 100)).toFixed(2);

        newTotalValue = parseFloat(prod.valorTotal - result);
      } else {
        newTotalValue = prod.valorTotal - prod.desconto;
      }

      return maskCurrency(newTotalValue);
    },

    assignProduct(orderItem) {
      this.lineSimpleItem = orderItem;

      this.$refs.refQtd.valueInput = orderItem.quantidade;
      this.$refs.refVlUnit.valueInput = orderItem.valorUnitario;
      this.$refs.valorTotal.valueInput = orderItem.valorTotal;
      this.$refs.discount.valueInput = orderItem.desconto;
      this.$refs.dadosAdicionais.valueInput = orderItem.dadosAdicionais;

      this.handleCalculateTotal();
    },

    clearLineProduct() {
      this.lineSimpleItem = {
        ...this.lineSimpleItem,
        id: "",
        idOrdemProducao: "",
        idFornecedor: "",
        quantidade: 1,
        dadosAdicionais: "",
        estoque: 0,
      };

      if (!this.keepItems) {
        this.lineSimpleItem = {
          ...this.lineSimpleItem,
          idProduto: "",
          altura: 0,
          largura: 0,
          metragem: 0,
          valorUnitario: 0,
          valorTotal: 0,
          porcentagemPerda: 0,
          idCor: "",
          idAmbiente: "",
          linear: false,
          tipoPreco: "P1",
        }

        if (!this.discountToAllItems) {
          this.lineSimpleItem.desconto = 0;
          this.$refs.discount.valueInput = 0;
        }

        this.toggleClearSelect = !this.toggleClearSelect;
        this.prevSelectedProduct = null;

        let discountValue = 0;
        if (this.lineSimpleItem.tipoDesconto === "porcentagem") {
          const result = (
            this.lineSimpleItem.valorTotal *
            (this.lineSimpleItem.desconto / 100)
          ).toFixed(2);

          discountValue = parseFloat(result);
        } else {
          discountValue = this.lineSimpleItem.desconto;
        }

        this.$refs.valorTotal.valueInput = this.lineSimpleItem.valorTotal - discountValue;
        this.$refs.refVlUnit.valueInput = this.lineSimpleItem.valorUnitario;
      } else {
        this.$refs.valorTotal.valueInput = this.lineSimpleItem.valorTotal;
      }

      this.$refs.refQtd.valueInput = 1;
      this.$refs.dadosAdicionais.valueInput = "";
    },

    handleModalCreateProduct(nameModal, idProduct) {
      this.idProductFromSearch = idProduct;
      this.openModals(nameModal);
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleCalculateTotal() {
      const amount = Number(this.lineSimpleItem.quantidade);
      const unitaryValue = this.lineSimpleItem.valorUnitario;
      const totalValue = amount * unitaryValue;

      if (!this.$refs.valorTotal) return;

      this.lineSimpleItem.valorTotal = totalValue;

      let discountValue = 0;

      if (this.lineSimpleItem.tipoDesconto === "porcentagem") {
        const result = (
          this.lineSimpleItem.valorTotal *
          (this.lineSimpleItem.desconto / 100)
        ).toFixed(2);

        discountValue = parseFloat(result);
      } else {
        discountValue = this.lineSimpleItem.desconto;
      }

      this.$refs.valorTotal.valueInput = totalValue - discountValue;
    },

    handleCreatedNewCustomer() {
      this.createdNewCustomer = !this.createdNewCustomer;
    },

    clearAllRefs() {
      this.$refs.valorTotal.valueInput = 0;
      this.$refs.refVlUnit.valueInput = 0;
    },

    handleItemSelected(product) {
      this.selectedItemIdToReplace = product.idProduto;

      this.editProductsOfProductionOrder(product)
    },

    editProductsOfProductionOrder(prod) {
      try {
        this.editProd = {
          edit: true,
          prod,
        };

        const newProd = removeReference(prod);
        this.assignProduct(newProd);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao editar o produto",
          type: "info",
        });
      }
    },

    assignTotalItensValues() {
      const valorTotal = this.tableProducts.reduce((oldValue, product) => {
        return oldValue + +(+product.valorTotal.toFixed(2));
      }, 0
      );

      this.$emit('totalOfItensSimple', valorTotal)
    },

    assignTotalDiscount() {
      let totalOfDiscount = 0

      if (this.discountIsCheked) {
        totalOfDiscount = this.calculateTotalDiscount();
      } else {
        totalOfDiscount = this.calculateTotalDiscountWithMonetaryValue();
      }

      this.$emit('discountOfItensSimple', totalOfDiscount)
    },

    cleanCurrency(value) {
      if (typeof value === "number") return value;
      if (!value) return 0;
      let cleaned = String(value).replace(/[^\d,.-]/g, "");
      if (cleaned.indexOf(",") !== -1) {
        cleaned = cleaned.replace(/\./g, "");
        cleaned = cleaned.replace(",", ".");
      }
      return parseFloat(cleaned) || 0;
    },

    calculateTotalDiscount() {
      const discounts = this.tableProducts.map((prod) => {
        const desc = prod.desconto;
        const totalValue = prod.valorTotal;

        return +((totalValue * desc) / 100).toFixed(2);
      });

      const totalValueWithDiscount = discounts.reduce(
        (oldValue, desc) => oldValue + desc,
        0
      );

      return totalValueWithDiscount
    },

    calculateTotalDiscountWithMonetaryValue() {
      const monetaryDiscounts = this.tableProducts.map(
        (prod) => {
          if (prod.desconto) {
            const desc = prod.desconto;

            return desc;
          }

          return 0;
        }
      );

      const totalMonetaryWithDiscount = monetaryDiscounts.reduce(
        (oldValue, desc) => oldValue + desc,
        0
      );

      return totalMonetaryWithDiscount
    },

    alterAllChecksDiscount() {
      if (this.discountToAllItems) {
        this.$refs.typeDiscount.checked = true;

        this.assignTotalItensValues();
        this.assignTotalDiscount();
      }
    },

    clearAll() {
      this.clearLineProduct()
      this.tableProducts = []
      this.assignTotalDiscount()
      this.assignTotalItensValues()
    },

    handleCreatedNewProduct() {
      this.createdNewProducts = !this.createdNewProducts;
    },

    handleCalculateTotalsValues() {
      this.assignTotalItensValues();
      this.assignTotalDiscount();
    },
  },
  async mounted() {
    await this.$nextTick()

    if (this.productionOrder.id) {
      await this.findTableItemsOfProducionOrder()
      this.handleCalculateTotalsValues()
    }
  },
  filters: {
    moment(data) {
      return moment(data).format("DD/MM/YYYY");
    },
  },
  computed: {
    ...mapState({
      dataConfig: (state) => state.dataConfig,
    }),

    lossPercentage() {
      if (this.dataConfig) {
        return Number(this.dataConfig.venda_mtq.porcentagem_perda)
      }

      return 2
    },
    keepItems() {
      // Descomentar caso o cliente precise, pois como é uma Ordem de produção não sei se faz sentido deixar
      // if (Object.keys(this.dataConfig).length) {
      //   return Number(this.dataConfig?.venda_mtq?.manter_itens)
      // }

      return false;
    },
    validatorDesc() {
      let existsDiscount = false;

      if (this.tableProducts.length) {
        for (const product of this.tableProducts) {
          if (product.desconto) {
            existsDiscount = true;
            break;
          }
        }
      }

      return existsDiscount;
    },
    isBlockStock() {
      return this.dataConfig?.venda?.bloqueio_estoque
    },
    isActiveReplaceAll() {
      return !!this.selectedItemIdToReplace
    },
    isClear() {
      return this.productionOrder.id
    }
  },
  watch: {
    prevSelectedProduct() {
      if (this.isActiveReplaceAll)
        this.updateProductValue("P1")
    },
    isClear() {
      if (!this.isClear) this.clearAll();
    }
  },
  beforeDestroy() {
  }
}
